// extracted by mini-css-extract-plugin
export default {"personailty":"PersonalityFactors-module__personailty__cjKmn","factorContainer":"PersonalityFactors-module__factorContainer__t6+Rs"};